<ez-main-layout>
  <ez-banner>
    <span ngProjectAs="title">Willkommen bei Ihrer Versicherung</span>
    <span ngProjectAs="subtitle">Bitte verifizieren Sie sich mit Ihrem Zugangscode</span>
  </ez-banner>
  <h3>Ihr persönlicher Zugangscode</h3>
  <p>Bitte geben Sie im nachfolgenden Feld Ihren persönlichen Zugangscode aus dem Anschreiben ein.</p>
  <form class="form-body" [formGroup]="personalAccessTokenForm" (ngSubmit)="onSubmit()">
    <input
      type="password"
      placeholder="Bitte Zugangscode eingeben"
      formControlName="personalAccessToken"
      [class.error]="errorMessage()"
    />
    @if (errorMessage(); as message) {
      <span class="error-message">{{ message }}</span>
    }
    <ez-button
      id="tokenSubmitButton"
      buttonType="submit"
      maxWidth="300px"
      [disabled]="!personalAccessTokenForm.valid"
      label="Senden"
    ></ez-button>
  </form>
</ez-main-layout>
